<template>
	<div>
		<div class="ser-form ser-form-centered">
			<div class="form-item-label margin-right">筛选搜索</div>
			<div class="form-item-content">
				<RadioGroup v-model="serData.status">
					<Radio :label="0">隐藏</Radio>
					<Radio :label="1">显示</Radio>
				</RadioGroup>
				<Input class="margin-right" v-model="serData.value" placeholder="输入名称搜索" style="width: 200px" />
				<Select v-model="serData.class_type" style="width:200px" class="margin-right" :clearable="true"
					placeholder="请选择操作类型">
					<Option v-for="(item,index) in class_data" :value="index" :key="index">{{ item }}
					</Option>
				</Select>
				<Button type="primary" @click="init()" class="margin-right">搜索</Button>
				<Button type="primary" icon="md-add" @click="openModal()">新增设备操作</Button>
			</div>
		</div>
		<div class="table-list">
			<Table :columns="columns" :data="data" :loading="loading">
				<template slot-scope="{row,index}" slot="operation">
					<Button @click="openModal(index)" style="margin-right: 8px;">编辑</Button>
					<!-- <Button @click="del(row.id)">删除</Button> -->
				</template>
				<template slot-scope="{row}" slot="image">
					<Tooltip :content="row.image" placement="top" :transfer="true" :events-enabled="true"
						max-width="200">
						<div class="text-ellipsis">{{ row.image }}</div>
					</Tooltip>
				</template>
				<template slot-scope="{row}" slot="all_model_name">
					<Tooltip :content="row.all_model_name" placement="top" :transfer="true" :events-enabled="true"
						max-width="200">
						<div class="text-ellipsis">{{ row.all_model_name }}</div>
					</Tooltip>
				</template>
			</Table>
		</div>
		<div class="ser-page">
			<Page class-name="page-r" :total="total" :page-size="serData.pageSize" :page-size-opts="[15,30,50]"
				@on-change="changePage" @on-page-size-change="changePageSize" show-total show-sizer></Page>
		</div>
		<Modal v-model="device_modal" :title="formData.id?'编辑设备操作':'添加设备操作'">
			<Form ref="formValidate" :model="formData" :rules="ruleValidate" :label-width="100">
				<FormItem label="操作名称" prop="name">
					<Input v-model="formData.name" placeholder="请输入操作名称"></Input>
				</FormItem>
				<FormItem label="图片路径" prop="image">
					<Input v-model="formData.image" placeholder="请输入图片路径"></Input>
				</FormItem>
				<FormItem label="操作项分类" prop="class_type">
					<RadioGroup v-model="formData.class_type">
						<Radio :label="0">健康守护</Radio>
						<Radio :label="1">安全守护</Radio>
						<Radio :label="2">设备控制</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="是否显示" prop="status">
					<RadioGroup v-model="formData.status">
						<Radio :label="0">否</Radio>
						<Radio :label="1">是</Radio>
					</RadioGroup>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="save">保存</Button>
				<Button @click="device_modal=false">取消</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//健康数据标识
				healthTypeArr: [{
					val: 0,
					text: '心率'
				}, {
					val: 1,
					text: '体温'
				}, {
					val: 2,
					text: '血压'
				}, {
					val: 3,
					text: '血氧'
				}, {
					val: 4,
					text: '血糖'
				}, {
					val: 5,
					text: '步数'
				}, {
					val: 6,
					text: '睡眠'
				}],
				columns: [{
						title: 'ID',
						key: 'id',
					},
					{
						title: '名称',
						key: 'name',
					},
					{
						title: '图片路径',
						slot: 'image',
						minWidth: 100
					},
					{
						title: '设备操作项分类',
						key: 'class_type',
						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Tag', {
									props: {
										color: 'success'
									}
								}, params.row.class_type ? (params.row.class_type == 1 ? '安全守护' :
									'设备控制') : '健康守护')
							])
						}
					},
					{
						title: '是否显示',
						key: 'status',
						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Tag', {
									props: {
										color: params.row.status ? 'success' : 'error'
									}
								}, params.row.status ? '显示' : '隐藏')
							])
						}
					},
					{
						title: '操作',
						slot: 'operation',
						minWidth: 150
					}
				],
				data: [],
				class_data: ['健康守护', '安全守护', '设备控制'],
				ruleValidate: {
					name: [{
						required: true,
						type: 'string',
						message: '请输入名称',
						trigger: 'blur'
					}],
					image: [{
						required: true,
						type: 'string',
						message: '请输入图片路径',
						trigger: 'blur'
					}],
					link: [{
						required: true,
						type: 'string',
						message: '请输入链接或方法',
						trigger: 'blur'
					}]
				},
				formData: {
					id: null,
					name: null,
					image: null,
					class_type: 0,
					status: 1,
				},
				serData: {
					page: 1,
					pageSize: 15,
					class_type: null,
					status: 1,
					value: null,
				},
				device_modal: false,
				model_data: [], //类型
				loading: false,
				total: 0,

			}
		},
		methods: {
			init() {
				this.loading = true
				var _this = this
				this.requestApi('/adm/get_operation_button_data', {
					data: this.serData
				}).then(function(res) {
					_this.loading = false
					if (res.status == 200) {
						_this.total = res.data.total
						_this.data = res.data.data
						_this.model_data = res.model_data
						_this.op_data = res.op_data
					} else {
						_this.alertErr(res.msg)
					}
				})
			},
			changePage(page) {
				this.serData.page = page;
				this.init()
			},
			changePageSize(size) {
				this.serData.page = 1;
				this.serData.pageSize = size;
				this.init()
			},
			//打开编辑设备操作框
			openModal(e = null) {
				if (e != null) {
					var obj = JSON.parse(JSON.stringify(this.data[e]))
					for (var i in obj['model_id']) {
						obj['model_id'][i] = parseInt(obj['model_id'][i]);
					}
					this.formData = obj
				} else {
					this.formData.id = null
					this.formData.name = null
					this.formData.image = null
					this.formData.class_type = 0
					this.formData.status = 1
				}
				this.device_modal = true
			},
			//编辑设备操作
			save() {
				var _this = this;
				this.$refs.formValidate.validate((valid) => {
					if (valid) {
						this.requestApi('/adm/edit_operation_button_data', {
							data: this.formData,
						}).then(function(res) {
							if (res.status == 200) {
								_this.device_modal = false
								_this.alertSucc(res.msg)
								_this.init()
							} else {
								_this.alertErr(res.msg)
							}
						})
					}
				})
			},
			//删除设备操作
			del(id) {
				var _this = this
				this.$Modal.confirm({
					title: '提示',
					content: '确定删除该设备操作吗？',
					onOk: (res) => {
						this.requestApi('/adm/del_operation_button_data', {
							id: id
						}).then(function(res) {
							if (res.status == 200) {
								_this.alertSucc(res.msg)
								_this.init()
							} else {
								_this.alertErr(res.msg)
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.ser-form-centered {
		display: flex;
		align-items: center;
	}

	.margin-right {
		margin-right: 10px;
	}

	.color_css {
		color: #999;
	}

	.text-ellipsis {
		width: 200px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.frame_class {
		padding: 10px;
		background-color: #fff;
	}
</style>